import cn from 'classnames';
import { Newsletter } from '../../components/CTA/Newsletter/Newsletter';
import { Card } from '../../components/Card';
import { Footer } from '../../components/Footer';
import { HeroSection } from '../../components/HeroSection';
import { ScheduleTable } from '../../components/Tables/ScheduleTable';
import { Link } from '../../components/Link';
import { HomeMachineState } from '../../machines/HomeMachine';
import { Loading } from '../../components/Loading';
import { ErrorPage } from '../ErrorPage';

import styles from './Home.module.scss';
import { Feedback } from '../../components/Feedback';

interface HomeViewProps {
  state: HomeMachineState;
  isSignedIn: boolean;
}

export function HomeView({ state, isSignedIn }: HomeViewProps) {
  if (state.matches('init')) {
    return <Loading />;
  }

  if (state.matches('initError')) {
    return <ErrorPage />;
  }

  return (
    <>
      <Feedback type="warning" className={styles.roundWarning}>
        <p className="body-text-bold">
          IMPORTANT INFORMATION REGARDING CANADIAN STARMAKER FUNDING ROUND #95
          (September 2025)
        </p>
        <p>
          The Canadian Starmaker Fund is committed to remaining an essential
          aspect of supporting artists through our core touring and Orion
          programs now and into the future. Currently, however, we have come to
          an impasse with funding being withheld by online streaming platforms
          as they navigate appeals through the Federal Court, and a new funding
          regime is to be determined by the CRTC in the fall of 2025. Without
          certainty regarding levels of funding, we are unable to make any
          further commitments past round #94.
        </p>
        <p>
          <span className="body-text-bold">
            TO OUR ARTIST CLIENTS specifically
          </span>
          , rest assured that the Canadian Starmaker Fund remains fully
          operational. All presently committed grants will be paid in the normal
          course as funding contracts are fulfilled and submitted. The website
          will be operational but will not allow any future applications to be
          submitted until further notice. We have taken every possible step to
          streamline our operation and participate fully in discussion and
          negotiations surrounding new potential sources of funding and we are
          committed to ensuring there is long term stability for the Fund. Our
          sincere hope is that this remain a simple matter of timing and to be
          prudent we need to press “pause” for the time being. We hope to have
          these funding questions resolved and conduct round #95 early in the
          new year.
        </p>
      </Feedback>
      <main className={styles.container}>
        <HeroSection
          title="Canadian Starmaker Fund"
          {...(isSignedIn
            ? {
                primaryButtonText: 'View Your Artists',
                primaryButtonLinkTo: '/artists',
              }
            : {
                primaryButtonText: 'Start Core Funding Application',
                primaryButtonLinkTo: '/eligibility',
                secondaryButtonText: 'Start Orion Application',
                secondaryButtonLinkTo: '/eligibility/orion',
              })}
          rounded={true}
        >
          <p>
            Working to create a substantial and discernible difference in the
            careers of emerging Canadian artists from all cultural backgrounds.{' '}
            <Link href="/about" className={styles.link}>
              Learn more about the fund
            </Link>
            .
          </p>
        </HeroSection>
        <div className={cn('max-w-xl', styles.collapseRow)}>
          <div className={styles.table}>
            <ScheduleTable rounds={state.context.rounds} />
          </div>
          <div className={styles.reqsAndOrion}>
            <Card
              width="md"
              title="Requirements & Rules"
              icon="list"
              linkTo="/requirements"
            />
            <Card
              width="md"
              title="Orion Program"
              icon="file"
              linkTo="/orion"
            />
          </div>
        </div>
        <div className={styles.home}>
          <div className={styles.faq}>
            <h2>Frequently Asked Questions</h2>
            <div className={cn('max-w-xl', styles.collapseRow)}>
              <Card
                icon="requirements"
                title="Does My Project Qualify?"
                linkTo="/faq/#Does My Project Qualify?"
              />
              <Card
                icon="helpCircle"
                title="What Do I Need to Know to Apply?"
                linkTo="/faq/#What Do I Need To Know To Apply?"
              />
              <Card
                icon="award"
                title="Next Steps After Funding Approval?"
                linkTo="/faq/#If I'm Approved For RSF Funding, What Happens Next"
              />
            </div>
          </div>
          <Newsletter />
        </div>
        <Footer />
      </main>
    </>
  );
}
